import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ palette }) => ({
  container: {
    width: 720,
  },
  heading: {
    borderBottom: `1px solid ${palette.grey[200]}`,
  },
  headingText: {
    fontSize: 21,
    fontWeight: 600,
  },
  checkboxContainer: {
    marginBottom: 48,
  },
}));

export default useStyles;
